module.exports = __webpack_public_path__ + "img/tu03.72bee35d.jpg";